export function Spinner({ small = false }: { small?: boolean }) {
  return <span className={`spinner ${small ? "spinner-small" : ""}`} aria-hidden="true" />;
}

export function LoadingScreen({ label = "Loading..." }: { label?: string }) {
  return (
    <main className="full-screen-center gradient-bg">
      <div className="loading-stack">
        <img src="/limitx.png" className="loading-logo" alt="LimitX" />
        <Spinner />
        <p className="muted">{label}</p>
      </div>
    </main>
  );
}

export function LoadingPanel({ label = "Loading data..." }: { label?: string }) {
  return (
    <div className="loading-panel">
      <Spinner />
      <span className="muted">{label}</span>
    </div>
  );
}
